module.exports = __webpack_public_path__ + "img/money-free.61ca26f0.svg";